import breakpoints from 'themeV5/breakpoints';

const HUGE = '96px';
const XXXL = '60px';
const XXL = '40px';
const XL = '32px';
const L = '28px';
const M = '24px';
const BODY1 = '20px';
const BODY2 = '16px';
const LINK1 = '20px';
const LINK2 = '16px';
const S = '14px';
const XS = '12px';

export const basicSettings = {
  huge: {
    lineHeight: '136px',
    letterSpacing: 0,
    fontSize: XXL,
    ...responsiveFontSizes({ md: XXL, lg: HUGE }),
  },
  xxxl: {
    lineHeight: '88px',
    letterSpacing: 0,
    fontSize: XL,
    ...responsiveFontSizes({ md: XL, lg: XXXL }),
  },
  xxl: {
    lineHeight: '56px',
    letterSpacing: 0,
    fontSize: L,
    fontFamily: 'FSSiena-Regular',
    ...responsiveFontSizes({ md: L, lg: XXL }),
  },
  xl: {
    lineHeight: '48px',
    letterSpacing: 0,
    fontSize: L,
    fontFamily: 'FSSiena-Regular',
    ...responsiveFontSizes({ md: L, lg: XL }),
  },
  l: {
    lineHeight: '40px',
    letterSpacing: 0,
    fontSize: M,
    fontFamily: 'FSSiena-Regular',
    ...responsiveFontSizes({ md: M, lg: L }),
  },
  m: {
    lineHeight: '32px',
    letterSpacing: 0,
    fontSize: BODY1,
    ...responsiveFontSizes({ md: BODY1, lg: M }),
  },
  body1: {
    lineHeight: '28px',
    letterSpacing: 0,
    fontSize: BODY2,
    ...responsiveFontSizes({ md: BODY2, lg: BODY1 }),
  },
  body2: {
    lineHeight: '24px',
    letterSpacing: 0,
    fontSize: BODY2,
    ...responsiveFontSizes({ md: BODY2, lg: BODY2 }),
  },
  link1: {
    lineHeight: '28px',
    letterSpacing: 0,
    fontSize: LINK2,
    ...responsiveFontSizes({ md: LINK2, lg: LINK1 }),
  },
  link2: {
    lineHeight: '24px',
    letterSpacing: 0,
    fontSize: LINK2,
    ...responsiveFontSizes({ md: LINK2, lg: LINK2 }),
  },
  s: {
    lineHeight: '20px',
    letterSpacing: 0,
    fontSize: S,
    ...responsiveFontSizes({ md: S, lg: S }),
  },
  xs: {
    lineHeight: '16px',
    letterSpacing: 0,
    fontSize: XS,
    ...responsiveFontSizes({ md: XS, lg: XS }),
  },

  ///////// NEW TYPOGRAPHY GUIDE ////////
  headline: {
    lineHeight: '32px',
    letterSpacing: 0,
    fontSize: M,
    fontFamily: 'Parmisan-Regular',
  },
  tittle1: {
    lineHeight: '44px',
    letterSpacing: 0,
    fontSize: L,
    fontFamily: 'FSSiena-Regular',
    ...responsiveFontSizesLineHeight({
      md: XL,
      mdLineHeight: '44px',
      lg: XXL,
      lgLineHeight: '56px',
    }),
  },
  title2: {
    lineHeight: '44px',
    letterSpacing: 0,
    fontSize: L,
    fontFamily: 'FSSiena-Regular',
    ...responsiveFontSizesLineHeight({
      md: L,
      mdLineHeight: '44px',
      lg: XL,
      lgLineHeight: '48px',
    }),
  },
  subheadlingMini: {
    lineHeight: '24px',
    letterSpacing: 0,
    fontSize: BODY2,
    ...responsiveFontSizesLineHeight({
      md: BODY2,
      mdLineHeight: '24px',
      lg: BODY1,
      lgLineHeight: '28px',
    }),
  },
  subheadling: {
    lineHeight: '28px',
    letterSpacing: 0,
    fontSize: BODY1,
    ...responsiveFontSizesLineHeight({
      md: BODY1,
      mdLineHeight: '28px',
      lg: BODY1,
      lgLineHeight: '28px',
    }),
  },
  body: {
    lineHeight: '24px',
    letterSpacing: 0,
    fontSize: BODY2,
    ...responsiveFontSizesLineHeight({
      md: BODY2,
      mdLineHeight: '24px',
      lg: BODY2,
      lgLineHeight: '24px',
    }),
  },
  callout: {
    lineHeight: '20px',
    letterSpacing: 0,
    fontSize: S,
    ...responsiveFontSizesLineHeight({
      md: S,
      mdLineHeight: '20px',
      lg: S,
      lgLineHeight: '20px',
    }),
  },
  calloutBig: {
    lineHeight: '20px',
    letterSpacing: 0,
    fontSize: S,
    ...responsiveFontSizesLineHeight({
      md: S,
      mdLineHeight: '20px',
      lg: BODY2,
      lgLineHeight: '24px',
    }),
  },
};

export function responsiveFontSizes({ md, lg }) {
  return {
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      fontSize: md,
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      fontSize: lg,
    },
  };
}

export function responsiveFontSizesLineHeight({
  md,
  mdLineHeight,
  lg,
  lgLineHeight,
}) {
  return {
    [`@media (min-width:${breakpoints.values.sm}px)`]: {
      fontSize: md,
      lineHeight: mdLineHeight,
    },
    [`@media (min-width:${breakpoints.values.lg}px)`]: {
      fontSize: lg,
      lineHeight: lgLineHeight,
    },
  };
}
